import { Component, input, InputSignal, output } from "@angular/core";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { LowerCasePipe } from "@angular/common";

/**
 * Intro-page for every category
 *
 * Provides an overview of what the category of questions is about.
 */
@Component({
  selector: "bko-category-intro",
  imports: [ButtonComponent, LowerCasePipe],
  templateUrl: "./category-intro.html",
  styleUrl: "./category-intro.scss",
})
export class CategoryIntro {
  title: InputSignal<string> = input("Tittel på kategori");
  description: InputSignal<string> = input("Tekstlig beskrivelse av kategori med motivasjon");
  imageUri: InputSignal<string> = input.required();
  imageType: InputSignal<string> = input(undefined);
  showPreviousButton: InputSignal<boolean> = input(true);
  next = output<void>();
  previous = output<void>();

  handleNextClick(): void {
    this.next.emit();
  }

  handlePreviousClick(): void {
    this.previous.emit();
  }
}
